import React from "react";
import { useNavigate } from "react-router-dom";
import "./Catalog.scss";

const Catalog = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/katalog'); // Correct route path
  };

  return (
    <div id="catalog" className="katalog-container">
      <div className="katalog-header">
        <h1>Dobrodošli u Naš Katalog</h1>
        <p>Pronađite sve što vam je potrebno za vaš poslovni uspeh. <br/>Naša ponuda uključuje širok spektar proizvoda i usluga koje možete pregledati na jednom mestu.</p>
      </div>
      <div className="katalog-description">
        <p>Uživajte u jednostavnom i prijatnom iskustvu pretrage kroz naš katalog. <br/>Kliknite na dugme ispod da biste otvorili katalog u novom prozoru.</p>
      </div>
      <button onClick={handleButtonClick} className="view-catalog-button">Pregledaj Katalog</button>
    </div>
  );
};

export default Catalog;
